// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/chats/components/chatlist/index.scss
// module id = 2366
// module chunks = 13